import styles from "../index.module.less";
import { Button } from "antd";
import QRCode from "qrcode";
import imageUrl from "../../../utils/imageUrl";
import { useEffect, useState } from "react";
import {
  CheckCircleFilled,
  WeiboSquareFilled,
  QqSquareFilled,
} from "@ant-design/icons";

export default function SuccessTip(props) {
  const { protocol, host } = location;
  const { newPin, autoCloseCounter, closeAfterDone } = props.viewModel;
  const [qrImageUrl, setQRImageUrl] = useState();
  const pinPageUrl = `${protocol}//${host}/pins/${newPin.pin_id}/`;
  const pinAvatar = imageUrl(newPin.file, { width: 100 });

  useEffect(() => {
    (async () => {
      const url = await new Promise((resolve, reject) =>
        QRCode.toDataURL(pinPageUrl, (err, url) =>
          err ? reject(err) : resolve(url)
        )
      );
      setQRImageUrl(url);
    })();
  }, [newPin, pinPageUrl]);

  return (
    <div className={styles.successTip}>
      <div className={styles.left}>
        <div className={styles.emptyHolder} />
        <div className={styles.successContainer}>
          <div className={styles.successTitle}>
            <CheckCircleFilled className={styles.anticon} /> 已经成功采集
          </div>
          <div className={styles.successTitle2}>
            据说这么好的东西是要分享给好友的~~~
          </div>
          {qrImageUrl ? (
            <img
              className={styles.successImage}
              src={qrImageUrl}
              alt={"二维码"}
            />
          ) : (
            <div className={styles.successImage} />
          )}
          <div className={styles.successTitle2}>微信扫码分享</div>
          <div className={styles.sharePanel}>
            <span>或</span>
            <WeiboSquareFilled
              className={styles.anticon}
              style={{ color: "pink" }}
            />
            <QqSquareFilled
              className={styles.anticon}
              style={{ color: "blue" }}
            />
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.emptyHolder}>
          &nbsp;
          {!!closeAfterDone && (
            <div className={styles.waitToClose}>
              {autoCloseCounter}秒后自动关闭窗口
            </div>
          )}
        </div>
        <div className={styles.successSummary}>
          <div className={styles.successCover}>
            <img src={pinAvatar} alt={"采集缩略图"} />
          </div>
          <div className={styles.successText1}>你已经成功采集到</div>
          <div className={styles.successText2}>{newPin.board.title}</div>
          <a rel="noreferrer" target="_blank" href={pinPageUrl}>
            <Button>查看采集</Button>
          </a>
        </div>
      </div>
    </div>
  );
}
